import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
import BookingList from '../Pages/BookingList'
import CalendarView from '../Pages/CalendarView'

function Loading() {
  return (
    <>
      <div className='wrapper'>
        <span>Loading</span>
      </div>
    </>
  )
}

function CalendarRoute() {
  const history = useHistory()

  return (
    <Switch>
      <Route
        exact
        path='/:lng/calendar'
        render={() => (
          <React.Fragment>
            <CalendarView history={history} />
          </React.Fragment>
        )}
      />

      <Route
        exact
        path='/:lng/calendar/bookings'
        render={() => (
          <React.Fragment>
            <BookingList history={history} />
          </React.Fragment>
        )}
      />

      <Route
        exact
        path='/:lng/calendar/booking/view/:slack'
        render={() => <WorkInProgress />}
      />
      <Route
        exact
        path='/:lng/calendar/booking/edit/:slack'
        render={() => <WorkInProgress />}
      />
      <Route path='/:lng/calendar/:unknown' render={() => <WorkInProgress />} />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(CalendarRoute)
